<template>
    <div>
        <Project  :client="client"
                  :product="product"
                  :tasks="tasks"
        />
        <transition appear name="slide-bot">
            <section class="grid-section" id="project-intro">
                <a href="#" v-scroll-to="'#project-content'" class="scroll-arrow">
                    <svg width="10px" height="72px" viewBox="0 0 10 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="arrow-down" fill-rule="nonzero">
                                <polygon id="arrow-copy" transform="translate(4.535534, 36.000347) rotate(-270.000000) translate(-4.535534, -36.000347) " points="38.6565072 36.4648132 -31.464119 36.4648132 -31.464119 35.4648132 38.5854393 35.4648132 35.2925461 32.17192 35.9996529 31.4648132 40.5351868 36.0003471 35.9996529 40.535881 35.2925461 39.8287743"></polygon>
                            </g>
                        </g>
                    </svg>
                </a>
                <img id="intro-content" src="@/assets/img/stray/stray-logo.svg" />
            </section>
        </transition>
        <section class="grid-section" id="project-content">
            <img src="@/assets/img/stray/stray-canyon.jpg" />
            <img src="@/assets/img/stray/stray-menu-1.jpg" />
            <img src="@/assets/img/stray/stray-inventory.jpg" />
            <img src="@/assets/img/stray/stray-pausemenu.jpg" />
            <img src="@/assets/img/stray/stray-items.jpg" />
        </section>

    </div>
</template>

<script>
    import Project from "@/components/Project.vue";

    export default {
        name: "Stray",
        components: {
            Project
        },
        data () {
            return {
                client: "Stråy",
                product: "Video Game 2020",
                tasks: {
                    task1: "UX Design & Identity",
                    task2: "Music Production & Sound Design",
                    task3: "Development",
                }
            }
        }
    };
    // TODO: FIX canyon image being overlayed
</script>

<style scoped>
    #project-intro
    {
        margin-bottom: 0;
        background-image: url("../assets/img/stray/intro-stray.jpg");
        background-size: cover;
    }

    #project-intro #intro-content
    {
        grid-column: 3 / 5;
        grid-row: 1 / 7;
        height: 50vh;
        justify-self: center;
        align-self: center;
    }

    .scroll-arrow {
        grid-column: 1 / 2;
        grid-row: 5 / 6;
        padding-right: 1.4rem;
        padding-left: 1.4rem;
        justify-self: right;
        align-self: end;
    }

    #project-intro .scroll-arrow g {
        fill: rgb(255,255,255);
    }

    #project-content {
        grid-template-rows: 0;
        height: auto;
        background-color: rgba(244,239,232,1);
        background-image: url("../assets/img/stray/stray-bg.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: 100%;
        padding-bottom: 0;
        padding-top: 20vh;
        margin-bottom: 0;
    }


    #project-content img {
        grid-column: 2 / 6;
        width: 100%;
        margin-bottom: 20vh;
        filter: drop-shadow(0 0.5rem 1.5rem rgba(0,0,0,0.25));
    }

</style>